import type { ReactElement } from "react";
import { Outlet } from "react-router-dom";

import { useAuth } from "@/hooks/useAuth";
import { useNotificationStream } from "@/hooks/useNotificationStream";

/**
 * Keeps the notifications SSE connection alive across AppShell ↔ FormFlowShell
 * navigations (e.g. open/close diary draft) so the stream does not reconnect
 * on every fullscreen enter/exit.
 */
export function NotificationStreamGate(): ReactElement {
  const { user } = useAuth();
  useNotificationStream(Boolean(user?.organization?.id));
  return <Outlet />;
}
